import { useEffect, useRef, useState } from "react"
import { observer } from "mobx-react"
//import { GenreTile } from "./GenreTile"
import { rootStore } from "store/RootStore"
import { useMediaQuery } from "hooks/useMediaQyery"
import tvImg from "img/relatedContent/fallback_image_tv.png"
import adultContent from "img/fallback/adult_content.png"
import { DiscoverConst } from "./DiscoverConst"
import { moment } from "store/util/moment"
//import defaultCoverImg from "img/cover-no-photo.gif"
import { Player } from "scenes/Player/Player"
import { channelId, eventId, startTs, endTs, eventPercentage, durationInHoursAndMinutes, startDateFormat, title } from "utils/EventHelpers"
import { formatMinutesLong } from "utils/IntlManager"
import { appFeatures } from "AppFeatures"
import { l10n } from "store/lang/L10n"

import "scenes/components/EpisodeAndRelatedTile.css"
//import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"

export const LiveTile = observer(({ page, origin, hasLiveTile }) => {
	const cocoBookmarks = rootStore.page.CoCoBookmarks
	const cocoDiscover = rootStore.page.CoCoDiscover
	const [refreshCount, setRefreshCount] = useState(0)
	const [liveProgress, setLiveProgress] = useState(0)
	const [firstTileMarginLeft, setFirstTileMarginLeft] = useState(0)
	const [modalActive, setModalActive] = useState(false)
	const videoContainer = useRef(null)

	const isMobile = useMediaQuery(`(max-width: ${DiscoverConst.mobileBreak}px)`)
	const isLiveOnLane = !useMediaQuery(`(max-width: ${DiscoverConst.laneLiveTileBreak}px)`)
	//const isMedium = useMediaQuery(`(min-width: ${DiscoverConst.mobileBreak + 1}px) and (max-width: ${DiscoverConst.mediumBreak}px)`)

	/*
	function refreshBookmark(event) {
		//console.debug("refreshBookmark", event)
		cocoBookmarks.setIgnoreEvent(null)
		cocoBookmarks.getBookmarkAsync(event, false).then((bm) => {
			//console.debug("LiveTile bookmark", bm, event)
			if (bm) {
				const barProgress = 100 * (bm.position - event?.AvailabilityStartTs) / (event?.AvailabilityEndTs - event?.AvailabilityStartTs)
				// MTVW-946: cap bookmark progress
				setBookmarkProgress(Math.min(barProgress, 100))
			}
			else setBookmarkProgress(null)
		})
	}
	*/

	function getLiveProgress() {
		if (!page.liveEvent) return 0
		return eventPercentage(page.liveEvent)
	}

	/* MTVW-996: commented
	useEffect(() => {
		const elem = document.getElementById("disPlayer")
		console.debug("useEffect ref.current", videoContainer, elem)
		if (elem) page.setVideoElem(elem)
	}, [videoContainer.current])
	*/

	useEffect(() => {
		const elem = document.getElementById("disPlayer")
		// MTVW-996
		if (elem) page.setVideoElem(elem)
		setFirstTileMarginLeft(page.firstTileMarginLeft[origin])
		document.addEventListener('visibilitychange', visibilityHandler)
		return () => {
			// MTVW-996
			page.setVideoElem(null)
			document.removeEventListener('visibilitychange', visibilityHandler)
		}
	}, [])

	useEffect(() => {
		if (page.firstTileMarginLeft[origin] !== firstTileMarginLeft) setFirstTileMarginLeft(page.firstTileMarginLeft[origin])
	}, [page.firstTileMarginLeft[origin]])

	/* MTVW-996: commented
	useEffect(() => {
		setRefreshCount(cocoBookmarks.refreshCount)
		// necessary?
		//page.fetchLiveEvent()
	}, [cocoBookmarks.refreshCount])
	*/

	useEffect(() => {
		setLiveProgress(getLiveProgress(getLiveProgress()))
		clearInterval(page.intervalId)
		page.intervalId = setInterval(() => {
			setLiveProgress(getLiveProgress())
		}, 10000)
	}, [page.liveEvent])

	useEffect(() => {
		const isModalActive = rootStore.page.OverlayEventDetails.isShow || page.isShow
		if (isModalActive) page.inActiveEvent()
		else if (modalActive) page.activeEvent()
		setModalActive(isModalActive)
	}, [rootStore.page.OverlayEventDetails.isShow, page.isShow])

	function visibilityHandler(e) {
		//console.debug("visibilityHandler", document.visibilityState, e)
		if (!rootStore.page.OverlayEventDetails.isShow && !page.isShow) {
			if (document.visibilityState === "visible") page.activeEvent()
			else page.inActiveEvent()
		}
	}

	const episodeProgramName = (item) => {
		if (rootStore.channelsService?.isChannelPinProtected(channelId(page.liveEvent))) {
			return l10n.featureContentPinProtected
		}
		return title(item)
		/*
		const season = item?.content?.Season ? `S${item?.content?.Season}` : ""
		const episode = item?.content?.Episode ? `E${item?.content?.Episode}` : ""
		const separator = season !== "" || episode !== "" ? " • " : ""
		const episodeName = item?.content?.EpisodeName ? separator + item?.content?.EpisodeName : separator + item?.content?.Title
		return `${season} ${episode} ${episodeName}`
		*/
	}

	const episodeDetails = (item) => {
		if (!item?.event) return ""
		// MTVW-1149: replace formatMinutesLong(Math.round(duration)) with durationInHoursAndMinutes to show hours and minutes, also for durations > 60min
		const duration = Number(item?.event?.endMillis - item?.event?.startMillis) / 60000
		return `${durationInHoursAndMinutes(null, duration)} • ${startDateFormat(item.event, "dd, DD.MM.")}, ${startDateFormat(item.event, "HH:mm")}`
	}

	const clickHandler = (e) => {
		// MTVW-996
		console.debug("clickHandler")
		rootStore.sso.selectLiveTv()
		// MTVW-996: done in notifyTabChange
		/*
		page.player.setIsPosterVisible(true, "LiveTile click", true)
		page.player.setRefElemContainer(null, true).then(() => {
			//rootStore.sso.selectLiveTv()
		})
		*/
	}

	const Poster = (item) => {
		// invalidate poster if channel changes 
		if (rootStore.channelsService.activeChannelId !== channelId(page.liveEvent)) return <></>
		if (rootStore.channelsService?.isChannelPinProtected(channelId(page.liveEvent))) {
			return <img loading="lazy" className="episodeImage" src={adultContent + "?mode=box&w=480&h=270"} />
		}
		const posterUrl = item?.content?.posterUrl ?? item?.content?._posterUrl
		if (posterUrl) return <img loading="lazy" className="episodeImage" src={posterUrl + "?mode=box&w=480&h=270"} />
		//else return <img loading="lazy" className="episodeImage" src={tvImg + "?mode=box&w=480&h=270"} />
		else return <></>
	}

	const Logo = (item) => {
		const logoUrl = rootStore.channelsService?.getChannel(channelId(page.liveEvent))?.logoUrl
		if (logoUrl) return <img loading="lazy" className="episodeChannelLogoIcon" src={logoUrl + "?mode=box&w=480&h=270"} />
		else return <></>
	}

	const recordingMarker = (item) => {
		//console.debug("recordingMarker", item)
		const evtId = eventId(item)
		return evtId ? rootStore.page.Recordings.Manager.getMarker(evtId) : null
	}

	const profileName = (item) => {
		const marker = recordingMarker(item)
		return marker?.ProfileId !== rootStore?.sso?.profile?.id ? rootStore.sso.getProfile(marker?.ProfileId)?.name : null
	}

	{/*<GenreTile key={"live_T"} variant={"episode"} isDragging={false} page={page} oEventData={liveEvent} item={liveEvent} ix={0} nbItems={1} origin={origin} hasLiveTile={true} />*/ }

	const tileWidth = isMobile ? window.innerWidth - 2 * DiscoverConst.marginMobile : DiscoverConst.tileWidth
	const tileStyle = {
		width: tileWidth, height: tileWidth / 16 * 9 + 104, marginTop: isMobile ? 40 : 0, marginLeft: isMobile ? 16 : 0,
		borderRadius: 8, border: "1px rgba(255, 255, 255, 0.10) solid"
	}

	let touchStart = 0

	//if (!page.liveEvent) return <div style={tileStyle} />
	return /*refreshCount > 0 &&*/ (
		<div key={"liveTile"} style={{ marginLeft: isMobile ? DiscoverConst.marginMobile : isLiveOnLane ? "" : DiscoverConst.marginMedium, marginTop: !isLiveOnLane ? DiscoverConst.liveTileTop : "" }}>
			<div className={"episodeTile"} style={{ width: tileStyle.width }}
				onClick={(e) => {
					e.stopPropagation()
					clickHandler(e)
				}}
			>
				<div className="episodeImageContainer" /*style={{ width: tileStyle.width }}*/ >
					<div
						onClick={(e) => {
							e.stopPropagation()
							clickHandler(e)
						}}
						onTouchStart={e => {
							touchStart = performance.now()
							e.stopPropagation()
							//clickHandler(e)
						}}
						onTouchEnd={e => {
							const touchEnd = performance.now()
							e.stopPropagation()
							//console.debug("touch", touchEnd - touchStart)
							if (touchEnd - touchStart < 100) clickHandler(e)
						}}
					>
						<div ref={videoContainer} id={"disPlayer"} /*style={getPlayerStyle(false)} channel-info={currentChannel}*/>
							<div style={{ width: tileStyle.width, height: tileStyle.width / 16 * 9, paddingTop: "0px" }} data-vjs-player>
								<video id={"vjs_" + "playerDis"} className='video-js' />
							</div>
						</div>
						<div style={{ display: page.playStarted ? "none" : "block" }}>
							{Poster(page.liveEvent)}
						</div>
					</div>
					{/*}
					<div className="profileNameShader" style={{ width: tileStyle.width }} id={`liveTile`} />
					*/}
					<div className="episodeIndicators">
						<div className="episodeIndicatorsFrame">
							<div className="episodeRecordingIndicator" />
						</div>
					</div>
					<div className="tileIndicators">
						{recordingMarker(page.liveEvent) &&
							<div className="recordingIndicator">
								<div className="recordingStatusIndicator">
									<div className="recordingStatusShape" />
								</div>
								{profileName(page.liveEvent) &&
									<div className="recordingProfileName">{profileName(page.liveEvent)}</div>
								}
							</div>
						}
						<div className="availabilityIndicators">
							<div className="liveIndicator">
								<div className="liveFrame">
									<div className="liveContainer">
										<div className="liveEllipse" />
									</div>
									<div className="liveLabel">{l10n.featureSearchLiveResult}</div>
								</div>
							</div>
						</div>
					</div>
					<div className="episodeChannelLogo" style={{ width: tileStyle.width }}>
						<div className="episodeChannelLogoShader" style={{ width: tileStyle.width }} />
						<div className="episodeChannelLogoFrame">
							<div className="episodeChannelLogoContainer" />
							{Logo(page.liveEvent)}
						</div>
					</div>
				</div>
				<div className="linearProgressBarContainer" style={{visibility: rootStore.channelsService?.isChannelPinProtected(channelId(page.liveEvent)) ? "hidden" : "visible"}}>
					<div className="linearProgressBackground" />
					<div className="linearProgress" style={{ width: liveProgress + "%" }} />
				</div>
				<div className="episodeInfoContainer">
					{/*!isLiveOnLane &&
						<div className="mobileLive">
							{l10n?.commonLabelLive?.toUpperCase()}
						</div>
					*/}
					<div className="episodeProgramName">{episodeProgramName(page.liveEvent)}</div>
					<div className="episodeDetails" style={{visibility: rootStore.channelsService?.isChannelPinProtected(channelId(page.liveEvent)) ? "hidden" : "visible"}}>
						{episodeDetails(page.liveEvent)}
					</div>
				</div>
			</div>
		</div>
	)
})
